import axios from 'axios';
import { submitPayloadDataFailure } from '../../../actions/digitalSavings/payloadCollection';

import { getIsApiPending, getPersonalDetailsForm } from '../../../selectors/digitalSavings/personalDetails';
import { getQuoteForm, getPremiumCalculation } from '../../../selectors/digitalSavings/quote';
import { getAccessToken } from '../../../selectors/digitalSavings/payment';
import { getAgentForm } from '../../../selectors/digitalSavings/agentModal';
import { setExpiredAuth } from '../../../actions/digitalSavings/quote';
import {
    apiTransitionDigitalSavingsPersonalDetailsForm,
    setQuoteId,
} from '../../../actions/digitalSavings/personalDetails';

export const personalDetailsSubmit = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionDigitalSavingsPersonalDetailsForm.pending());
            try {
                const resp = await calculate(store.getState(), action);
                store.dispatch(setQuoteId(resp.data.data.id));
                store.dispatch(apiTransitionDigitalSavingsPersonalDetailsForm.success());
            } catch (e) {
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                    store.dispatch(apiTransitionDigitalSavingsPersonalDetailsForm.initial());
                } else {
                    store.dispatch(apiTransitionDigitalSavingsPersonalDetailsForm.failure());
                }
                store.dispatch(submitPayloadDataFailure(e));
            }
        }
    })();
    return next(action);
};

const payloadCollection = (state, action) => {
    const quotation = getQuoteForm(state);
    const personalDetails = getPersonalDetailsForm(state);
    const premium = getPremiumCalculation(state);
    const agent = getAgentForm(state);

    function convertDateFormat(dateString) {
        try {
            // Split the date string into year, month, and day
            var parts = dateString.split('/');
            var day = parts[0];
            var month = parts[1];
            var year = parts[2];

            // Reformat the date string in the desired format
            var formattedDate = year + '/' + month + '/' + day;

            return formattedDate;
        } catch (error) {
            // Handle the case where the input string is not in the expected format
            return 'Invalid date format. Please use dd/mm/yyyy.';
        }
    }

    const premiumCalculationPayload = {
        // rowId: payload.payloadData ? payload.payloadData.quotation.userQuote.rowId : null,
        investorType: quotation.attitude.value === '2' ? 'Comfortable' : 'Adventurous',
        investmentPlan: quotation.saving_category.value || null,
        monthlyContribution: quotation.desired.value || 0,
        lumpsumContribution: quotation.lumpsum.value || 0,
        savingStartDate: convertDateFormat(quotation.startdate.value) || null,
        savingDuration: quotation.duration.value ? quotation.duration.value * 12 : null,
        totalPrincipalAmount: premium?.premium?.totalPrincipalAmount || null,
        potentialSavingsMin: premium?.premium?.potentialSavingsMin || null,
        potentialSavings: premium?.premium?.potentialSavingsMax || null,
    };

    const personalDetailsPayload = {
        countryCode: 'KE',
        quoteEmail: personalDetails.email.value || null,
        title: personalDetails.title.value || null,
        firstName: personalDetails.firstName.value || null,
        lastName: personalDetails.surname.value || null,
        dateOfBirth: convertDateFormat(personalDetails.dob.value) || null,
        gender: personalDetails.gender.value || null,
        nationality: personalDetails.nationality.value || null,
        occupation: personalDetails.occupation.value || null,
        sourceOfFunds: personalDetails.sourceOfFunds.value || null,
        employerName: personalDetails.employerName.value || null,
        salaryRange: personalDetails.salaryRange.value || null,
        identificationType: personalDetails.idPassport.value || null,
        idNumber: personalDetails.idNumber.value || null,
        passportNumber: personalDetails.passportNumber.value || null,
        kraNumber: personalDetails.kraPinNumber.value || null,
        phoneNumber: personalDetails.mobileNumber.value || null,
        emailAddress: personalDetails.email.value || null,
        postalAddress: personalDetails.postalBox.value || null,
        physicalAddress: personalDetails.fullAddress.value || null,
        sourceOfOtherFunds: personalDetails.sourceOfOtherFunds.value || null,
        sourceOfFundsDetails:
            quotation.desired.value >= 1000000 || quotation.lumpsum.value >= 1000000
                ? personalDetails.sourceOfFundsDetails.value
                : null,
        fundsFromLegitimateSource:
            quotation.desired.value >= 1000000 || quotation.lumpsum.value >= 1000000
                ? personalDetails.fundsFromLegitimateSource.value
                : false,
        informationIsTrueAndCorrect:
            quotation.desired.value >= 1000000 || quotation.lumpsum.value >= 1000000
                ? personalDetails.informationIsTrueAndCorrect.value
                : false,
        acceptPrivacyNotice:
            quotation.desired.value >= 1000000 || quotation.lumpsum.value >= 1000000
                ? personalDetails.acceptPrivacyNotice.value
                : false,
    };

    const agentPayload = {
        referrer: [
            {
                agentCode: agent.agentCode?.value,
                name: agent.name?.value,
                phoneNumber: 'N/A',
                emailAddress: null,
            },
        ],
    };

    return {
        ...premiumCalculationPayload,
        ...personalDetailsPayload,
        ...agentPayload,
    };
};

const calculate = async (state, action) => {
    const loginData = getAccessToken(state);

    try {
        const url = '/om-api/digital-savings/personal-details';
        return await axios.post(url, payloadCollection(state, action), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        throw e;
    }
};
